export const images: any = {
    brand: require('./brand.png'),
    avatar: require('./avatar.png'),
    amico: require('./amico.png'),
    hkapp: require('./hkapp.jpg'),
    bgLogo: require('./bg-logo.png'),
}